import axios from "axios";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";

export default {
    async getProfileByIds(ids: number[]): Promise<ProfileCardInterface[]> {
        return (await axios.post('/api/map/profile_cards', {
            ids,
        })).data
    }
}